import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

export const QLINE_TYPE_META = {
  labor:          { get label() { return I18n.t("quotes.new.cost_category.labor") },          icon: "user-clock",         tone: "bg-blue-50 text-blue-700 ring-blue-200" },
  equipment:      { get label() { return I18n.t("quotes.new.cost_category.equipment") },      icon: "screwdriver-wrench", tone: "bg-violet-50 text-violet-700 ring-violet-200" },
  materials:      { get label() { return I18n.t("quotes.new.cost_category.materials") },      icon: "boxes-stacked",      tone: "bg-emerald-50 text-emerald-700 ring-emerald-200" },
  subcontracting: { get label() { return I18n.t("quotes.new.cost_category.subcontracting") }, icon: "handshake",          tone: "bg-amber-50 text-amber-700 ring-amber-200" },
  other:          { get label() { return I18n.t("quotes.new.cost_category.other") },          icon: "ellipsis",           tone: "bg-slate-100 text-slate-700 ring-slate-200" },
}

export const TypeChip = ({ type }) => {
  const meta = QLINE_TYPE_META[type] || QLINE_TYPE_META.other
  return (
    <span className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[11px] font-medium whitespace-nowrap ring-1 ring-inset ${meta.tone}`}>
      <FontAwesomeIcon icon={meta.icon} className="w-3 h-3" />
      {meta.label}
    </span>
  )
}

export const FilterPill = ({ active, onClick, label, count }) => (
  <button
    type="button"
    onClick={onClick}
    className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-[12px] font-medium transition-colors ring-1 ring-inset ${
      active
        ? "bg-slate-900 text-white ring-slate-900"
        : "bg-white text-slate-600 ring-slate-200 hover:bg-slate-50"
    }`}
  >
    {label}
    {count != null && (
      <span className={`tabular-nums text-[10.5px] ${active ? "text-white/70" : "text-slate-400"}`}>
        {count}
      </span>
    )}
  </button>
)
